import { FEATURE } from '~/common/enums/feature.enum';
import { useTreatments } from '~/domains/common/hooks/useTreatments';

export const useEnableBannerAndAvatar = () => {
  const { isReady, treatments } = useTreatments([FEATURE.ENABLE_CONTEST_DETAILS_BANNER_AND_AVATAR]);
  const isBannerAndAvatarEnabled =
    treatments?.[FEATURE.ENABLE_CONTEST_DETAILS_BANNER_AND_AVATAR].treatment === 'on';

  return isBannerAndAvatarEnabled && isReady;
};
